import { render, staticRenderFns } from "./apartment-similar-products.vue?vue&type=template&id=1ae481f4&scoped=true&"
import script from "./apartment-similar-products.ts?vue&type=script&lang=ts&"
export * from "./apartment-similar-products.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-similar-products.scss?vue&type=style&index=0&id=1ae481f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae481f4",
  null
  
)

export default component.exports